import { render, staticRenderFns } from "./subjectList.vue?vue&type=template&id=40ac82bf&scoped=true"
import script from "./subjectList.vue?vue&type=script&lang=js"
export * from "./subjectList.vue?vue&type=script&lang=js"
import style0 from "./subjectList.vue?vue&type=style&index=0&id=40ac82bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac82bf",
  null
  
)

export default component.exports